export default function getPayload(data, dataIndex) {
  if (dataIndex === 'cncPercentage' || dataIndex === 'fabricationPercentage') {
    return { [dataIndex]: (data[dataIndex] / 100).toFixed(2) };
  }
  return { [dataIndex]: data[dataIndex] };
}
